import React from 'react';
import { useSelector } from 'react-redux';
import PetLoader from '../../loader';
import GetDataBtn from './GetDataBtn';
import SaveDataBtn from './SaveDataBtn';
import PngBtn from './PngBtn';
import {
  getCurrentTreeDataJson,
  isAdmin,
  lBfs,
  lCircle,
  lConcentric,
  lCose,
  lDagre,
  lElk,
  lGrid,
  lPreset,
  onClearData,
  refreshSummary,
} from '../scripts/cy-core';
import FullscreenBtn from './FullscreenBtn';
import GraphButton from '../../GraphButton';
import BackgroundBtn from './BackgroundBtn';
import SampleBtn from './SampleBtn';
import { Row, Space } from 'antd';

const TreeHeader = ({ cy }) => {
  const loading = useSelector((state) => state.tree.loading);
  const isSaving = useSelector((state) => state.tree.isSaving);
  const user = useSelector((state) => state.auth.user);

  const renderAdmin = () => {
    if (isAdmin())
      return (
        <tr>
          <td>
            <span>Layout</span>
          </td>
          <td>
            <GraphButton id="lElk" label="ELK" onClick={lElk} className="btn-layout hide" />
            <GraphButton id="lDagre" label="DAG" onClick={lDagre} className="btn-layout" />
            <GraphButton id="lBfs" label="BFS" onClick={lBfs} className="btn-layout" />
            <GraphButton id="lGrid" label="Grid" onClick={lGrid} className="btn-layout" />
            <GraphButton id="lPreset" label="Preset" onClick={lPreset} className="btn-layout" />
            <GraphButton id="lConc" label="Conc" onClick={lConcentric} className="btn-layout" />
            <GraphButton id="lCose" label="Cose" onClick={lCose} className="btn-layout" />
            <GraphButton id="lCircle" label="Circle" onClick={lCircle} className="btn-layout" />

            <GraphButton
              id="json"
              label="JSON"
              onClick={() => console.log(JSON.stringify(getCurrentTreeDataJson()))}
              className="btn-layout"
            />
          </td>
        </tr>
      );
    return null;
  };

  return (
    <div id="info" className="col-xs-12">
      <PetLoader show={isSaving || loading} />
      <div id="tree-data">
        {/* <div id="info1">
          <span>Tài khoản :</span>
          <span id="userId">{user?.userId}</span>
        </div> */}

        <Space direction="horizontal">
          <div id="nodeCountDiv">
            <span>Tổng: </span>
            <span id="nodeCount" />
          </div>
          <GetDataBtn />
        </Space>

        <SampleBtn />
      </div>

      <table id="control-table" className="col-xs-12">
        <tbody>
          <tr>
            <td></td>
            <td>
              <SaveDataBtn />

              <PngBtn cy={cy} />

              <GraphButton
                label="Refresh"
                onClick={refreshSummary}
                title="Sắp xếp lại theo chế độ mặc định"
                className="hide"
              />

              <GraphButton
                id="clearData"
                label="Xóa hết"
                onClick={onClearData}
                title="Xóa hết dữ liệu"
              />

              <BackgroundBtn cy={cy} />

              <GraphButton
                id="position"
                label="Position"
                title="Sắp xếp dạng Cây"
                className="hide"
              />
              <FullscreenBtn />
            </td>
          </tr>
          {renderAdmin()}
        </tbody>
      </table>
      <input type="hidden" id="userId" value={user?.userId} />
    </div>
  );
};

export default TreeHeader;
